import { shallowRef, computed, watch } from "vue";
import { defineStore } from "pinia";
import { useRoute } from "vue-router";

let sidebarShouldBeCollapsed = (routeName) => {
    return !['resumes', 'cover-letters.index', 'home', 'settings', 'help', 'services-tracker', 'auto-apply', 'interview-ai', 'auto-apply-applications', 'auto-apply-applications-table', 'admin-view', 'admin-view-subgroups', 'admin-view-subgroup-table', 'help.view'].some((e) => e === routeName)
}

export const useSidebarStore = defineStore("sidebar", () => {
    const collapsed = shallowRef(false);
    const route = useRoute();

    const resolveIfCollapsed = (routeName) =>
        window.innerWidth <= 900 ? true : sidebarShouldBeCollapsed(routeName);

    const sidebarCollapseHandler = () => {
        collapsed.value = !collapsed.value
    }
          
    const sidebarWidth = computed(() => collapsed.value ? '70px' : '220px')

    watch(() => route.name,
        async newName => {
          collapsed.value = resolveIfCollapsed(newName)
        }, { immediate: true }
    )

    return {
        collapsed,
        sidebarWidth,

        resolveIfCollapsed,
        sidebarCollapseHandler
    };
});
